import { sva } from '@news/styled-system/css'

export const featuredCarouselRecipe = sva({
    slots: ['slider', 'star'],
    base: {
        slider: {
            display: 'none',
            xlDown: {
                display: 'block',
                padding: '[20px]',
                maxWidth: '[90vw]',
                marginInline: 'auto',
            },
        },
        star: {
            marginBottom: '[8px]',
            marginRight: '[4px]',
        },
    },
})
